export enum BannerLinkTypeEnums {
  company = 'company',
  category = 'category',
  external = 'external',
}

export enum BannerTypeEnum {
  landing = 'landing',
  application = 'application',
}
